import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

/** At least one language field under the given prefix must be non-empty. */
export function atLeastOneLanguageValidator(fieldPrefix: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const controls = Object.keys(formGroup.value || {}).filter((key) =>
      key.startsWith(fieldPrefix)
    );
    const hasValue = controls.some((key) => {
      const value = formGroup.get(key)?.value;
      return value && String(value).trim().length > 0;
    });
    return hasValue ? null : { [`${fieldPrefix}Required`]: true };
  };
}

/** Image upload is required (existing preview URL or newly selected file). */
export function marketingImageRequiredValidator(hasImage: () => boolean): ValidatorFn {
  return (): ValidationErrors | null => {
    return hasImage() ? null : { imageRequired: true };
  };
}
